
import { Action, Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { DistributionState } from './types-store';
import { FieldItem } from '../../types';

export const INITIAL_STATE: DistributionState = {
  fetching: false,
  initialized: false,
  defaultFields: [],
  additionalFields: []
};

export const distributionReducers: { [indexer: string]: Reducer<DistributionState, Action> } = {
  [ACTION.CLEAR_DISTRIBUTION_STATE]: (state: DistributionState,
    action: actions.ClearDistributionState
  ): DistributionState => {
    return {
      ...state,
      ...INITIAL_STATE
    };
  },
  [ACTION.REQUEST_DISTRIBUTION_DEFAULT_FIELDS]: (state: DistributionState,
    action: actions.RequestDistributionDefaultFields
  ): DistributionState => {
    return {
      ...state,
      fetching: true
    };
  },
  [ACTION.RESPONSE_DISTRIBUTION_DEFAULT_FIELDS]: (state: DistributionState,
    action: actions.ResponseDistributionDefaultFields
  ): DistributionState => {
    return {
      ...state,
      fetching: false,
      initialized: true,
      defaultFields: action.options as FieldItem[]
    };
  },
  [ACTION.UPDATE_DEFAULT_DISTRIBUTION_FIELDS]: (state: DistributionState,
    action: actions.UpdateDistributionDefaultFields
  ): DistributionState => {
    return {
      ...state,
      defaultFields: action.options  as FieldItem[]
    };
  },
  [ACTION.RESPONSE_DISTRIBUTION_FIELDS]: (state: DistributionState,
    action: actions.ResponseDistributionFields
  ): DistributionState => {
    return {
      ...state,
      additionalFields: action.options  as FieldItem[]
    };
  }
};

export const distributionReducer = (state: DistributionState = INITIAL_STATE, action: any) => {
  const r = distributionReducers[action.type];
  return (r && r(state, action)) || state;
};
